import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ColorModeScript } from '@chakra-ui/react'
import { extendTheme } from "@chakra-ui/react"
import { ChakraProvider } from '@chakra-ui/react'
import { BrowserRouter } from 'react-router-dom';
import ChatProvider from './context/chatProvider';

const config = {
  initialColorMode: 'dark',
  useSystemColorMode: false,
}

const theme = extendTheme({
  config,
  images:{
    bg:{
      main1:"./assets/BodyBG.png",
      main2:"./assets/BodyBG2.png",
      mainAl:"./assets/BodyBG_alpha.png",
      mainAlBL:"./assets/BodyBG_alpha_blur.png",
    }
  },
  colors: {
    bgs:{
      bgsMain:"rgba(21, 48, 47, 0.63)",
      bgsMain2:"#8686868f",
      accntBx:"#86868680",
      gradBlk:"linear-gradient( 40deg,rgb(0, 0, 0) 0%,rgb(0, 0, 0) 25%,rgba(0, 0, 0, 0.827) 35%,rgba(47, 73, 73, 0.519) 50%,rgb(0, 0, 0) 70%, rgba(0, 0, 0, 0.683) 95%,rgba(0, 0, 0, 0.6) 100%);",
      chtBtnTxt: "rgba( 0, 0, 0, 0.6)",
      // chtBtnSel: " rgba(0, 0, 0, 0.8)",
      // chtBtnSel: " rgba(219,244,242, 0.4)",
      chtBtnSel: " rgba(21, 159, 218, 0.3)",
      // chtBtnTxt: "rgba(250, 250, 250, 0.4)",
      chtBtn: "rgba(250, 250, 250, 0.5)",
      // chtBtn: "rgba(112, 251, 251, 0.3)",
      userBtn: "rgba(112, 251, 251, 0.7)",
      // chtBtn: "rgba(0, 0, 0, 0.4)"
      // chtBtn: "rgba(0, 255, 0, 1)"
    },
    txt:{
      hdrDrk:"#868686",
      hdrLt:"#fff",
      chtBtnTxt: "rgba( 0, 0, 0, 1)",
      // chtBtnTxtSel: "rgba(250, 250, 250, 1)",
      chtBtnTxtSel: "rgba(21, 159, 218, 1)",
      // chtBtnTxtSel: "rgba(0, 255, 0, 1)",
      
    }
  },
  borders: {
    brd:{
      chtBtn: "2px solid rgba(51, 117, 218, 0.5)",
      chtBtnSel: "2px solid rgba(51, 117, 218, 1)",
      chtBtnAct: "3px ridge rgba(2, 248, 0, .6)",
      chtBtnActL: "3px solid rgba(2, 248, 0, .6)"
    },
  },

  shadows:{
    bxshd:{
      mainComp: "inset 0px 0px 15px 3px rgba(174,202,231, 0.7) ,0px 0px 10px 5px #8686868f",
      mainComp_ChtBx: "inset 0px 0px 15px 3px rgba(174,202,231, 0.7) ,0px 0px 10px 5px #8686868f",
      chtBtn: "-2px -2px 5px 0px rgba(51, 117, 218, 0.5)",
      homeBtn1: "-3px -4px 5px 0px rgba(51, 117, 218, 0.4)",
      homeBtn2: "3px -4px 5px 0px rgba(51, 117, 218, 0.4)",
      userBdg: "0px 0px 5px 0px rgba(51, 117, 218, 0.5)",
      inset_blk: "inset 0px 0px 15px 3px rgba(0,0,0, 0.7)",
      inset_lt_bl: "inset 0px 0px 15px 3px rgba(174,202,231, 0.7) ",
      inset_lt_bl2: "inset 0px 5px 15px 5px rgba(174,202,231, 0.7) ",
      inset_lt_bl_btm: "inset 0px 5px 15px 5px rgba(174,202,231, 0.7) "
    }}
})
  
// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <BrowserRouter>
//   <ChatProvider>
//       <ChakraProvider theme={theme}>
//          {/* <ColorModeScript initialColorMode={theme.config.initialColorMode} /> */}
   
//         <App />
//       </ChakraProvider>
//   </ChatProvider>
//     </BrowserRouter>

// );
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ChakraProvider theme={theme}>
    <BrowserRouter>
      <ChatProvider>
        <App />
      </ChatProvider>
    </BrowserRouter>
  </ChakraProvider>,
  // document.getElementById("root")
);
//  ReactDOM.render(
//   <ChakraProvider theme={theme}>
//     <BrowserRouter>
//       <ChatProvider>
//         <App />
//       </ChatProvider>
//     </BrowserRouter>
//   </ChakraProvider>,
//   document.getElementById("root")
// );
